export default {
  register: {
    title: '회원가입', username: '사용자 이름', phone: '전화번호', phoneCode: '코드', email: '이메일', password: '비밀번호', captcha: '인증 코드', smsCode: 'SMS 코드', emailCode: '이메일 코드',
    verificationCode: '이메일 인증 코드', invitationCode: '초대 코드', loading: '로딩 중...', send: '전송', sendCode: '코드 전송', signUp: '회원가입', contactUs: '문의하기？', haveAccount: '계정이 있으신가요?', signIn: '로그인', codeOptional: '코드 (선택사항)', privacyPolicy: '저는 18세 이상이며 다음에 동의합니다', privacyPolicyLink: '개인정보 보호정책', and: '및', termsConditions: '이용약관', vault: '금고', receivePromos: '이메일 프로모션 받기', usernameRequired: '사용자 이름을 입력하세요', usernameInvalid: '사용자 이름은 영문자, 숫자, 밑줄만 사용할 수 있습니다', phoneRequired: '전화번호를 입력하세요', phoneInvalid: '전화번호 형식이 올바르지 않습니다', emailRequired: '이메일을 입력하세요', emailInvalid: '이메일 형식이 올바르지 않습니다', passwordRequired: '비밀번호를 입력하세요', passwordInvalid: '비밀번호가 요구사항을 충족하지 않습니다', captchaRequired: '인증 코드를 입력하세요', smsCodeRequired: 'SMS 코드를 입력하세요', emailCodeRequired: '이메일 코드를 입력하세요', privacyPolicyRequired: '개인정보 보호정책 및 이용약관에 동의해주세요', passwordHintLow: '최소 6자리', passwordHintMedium: '영문자와 숫자를 포함한 6자 이상', passwordHintHigh: '영문자, 숫자, 기호를 포함한 6자 이상',
    // Format validation
    usernameFormat: '문자, 숫자, _만 사용 가능',
    emailFormat: '잘못된 이메일 형식',
    // Toast messages
    smsCodeSent: 'SMS 인증 코드 전송됨',
    emailCodeSent: '이메일 인증 코드 전송됨',
    smsCodeFailed: 'SMS 인증 코드 전송 실패',
    emailCodeFailed: '이메일 인증 코드 전송 실패',
    registerSuccess: '가입 성공',
    registerFailed: '가입 실패',
    // Google sign in
    signInWithGoogle: 'Google+로 로그인',
    loginNow: '로그인',
    or: '또는',
    orSignUpWith: '또는 다음으로 가입',
    methodUsername: '사용자 이름',
    methodPhone: '전화',
    methodEmail: '이메일',
  }
};
